import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  createTicket,
  deleteTicket,
  getTickets,
} from "../../../services/supportTickets";
import toast from "react-hot-toast";

function useSupportTickets() {
  const queryClient = useQueryClient();
  const ticketsData = useQuery({
    queryFn: getTickets,
    queryKey: ["tickets"],
  });

  const deleteSupportTicket = useMutation({
    mutationFn: (id) => deleteTicket(id),
    onSuccess: () => {
      queryClient.invalidateQueries(["tickets"]);
      toast.success("ticket has been deleted successfully!");
    },
    onError: () => {
      toast.error("error deleting support ticket");
    },
  });

  const createSupportTicket = useMutation({
    mutationFn: (supportTicketData) => createTicket(supportTicketData),
    onSuccess: () => {
      queryClient.invalidateQueries(["tickets"]);
      toast.success("support ticket has been created successfully");
    },
    onError: () => {
      toast.error("error creating support ticket");
    },
  });

  return {
    // TICKETS DATA
    ticketsData: ticketsData.data,
    isGettingTickets: ticketsData.isLoading,
    errorGettingTickets: ticketsData.error,

    // DELETE SUPPORT TICKET MUATION
    deleteSupportTicketFn: deleteSupportTicket.mutate,
    isDeletingSupportTicket: deleteSupportTicket.isLoading,

    // CREATE SUPPORT TICKET
    createSupportTicketFn: createSupportTicket.mutate,
    isCreatingSupportTicket: createSupportTicket.isLoading,
  };
}

export default useSupportTickets;
